import React from 'react';
import minBy from 'lodash/minBy';

import Button from 'src/legacy/Components/Forms/Button';
import {
  toMoney,
  toDatetime,
  toScheduleDate,
} from 'src/legacy/Utils/Conversor';
import eventStatus from 'src/legacy/Utils/eventStatus';

import { EventDetailTicketType, EventStatus } from 'src/types/dto';

import './MobileCart.scss';
import { PendingEventWarning } from './PendingEventWarning';
import { Icon, Text } from '@chakra-ui/react';
import { IoCloseCircle } from 'react-icons/io5';
import { PiClockBold } from 'react-icons/pi';

const isTicketTypeAvailable = (ticketType: EventDetailTicketType) =>
  new Date() < toDatetime(ticketType.sellEnd) && ticketType.quantity > 0;

const MobileCart: React.FC<{
  ticketTypes: EventDetailTicketType[];
  status: EventStatus;
  onButtonClick: () => void;
  hasTickets?: boolean;
  sellStartDate?: string | null;
  endDate?: string;
  isLoading: boolean;
}> = ({
  ticketTypes,
  status,
  onButtonClick,
  isLoading,
  hasTickets,
  sellStartDate,
  endDate,
}) => {
  const availableTicketTypes = ticketTypes.filter(isTicketTypeAvailable);
  const lowerTicketType = minBy(availableTicketTypes, 'price');

  const now = new Date();
  const endDateObj = new Date(endDate!);

  const wasFinished = endDateObj < now;

  const date = toScheduleDate(sellStartDate);

  if (sellStartDate && !hasTickets && status !== EventStatus.PendingWirecard) {
    return (
      <div className="mobile-cart">
        <div className="disabled-event orange">
          <div className="icon-wrapper">
            <Icon as={PiClockBold} boxSize="12" />
          </div>
          <div className="info">
            <span className="title"> Abertura programada</span>
            <span className="text">As vendas iniciam em {date}</span>
          </div>
        </div>
      </div>
    );
  }

  if (!lowerTicketType && hasTickets && !wasFinished) {
    return (
      <div className="mobile-cart">
        <div className="disabled-event red">
          <div className="icon-wrapper">
            <Icon as={IoCloseCircle} boxSize="12" />
          </div>
          <div className="info">
            <span className="title">Vendas online Encerradas</span>
            <span className="text">
              Vendas online encerradas. Consulte disponibilidade na bilheteria
              do evento.
            </span>
          </div>
        </div>
      </div>
    );
  }

  if (!sellStartDate && !hasTickets && !wasFinished) {
    return (
      <div className="mobile-cart">
        <div className="disabled-event red">
          <div className="icon-wrapper">
            <Icon as={IoCloseCircle} boxSize="12" />
          </div>
          <div className="info">
            <span className="title">Ingressos Indisponíveis</span>
            <span className="text">
              Não há ingressos disponíveis para esse evento
            </span>
          </div>
        </div>
      </div>
    );
  }

  if (status !== 2 && wasFinished) {
    return (
      <div className="mobile-cart">
        <div className="disabled-event red">
          <div className="icon-wrapper">
            <Icon as={IoCloseCircle} boxSize="12" />
          </div>
          <div className="info">
            <span className="title">Evento Encerrado</span>
            <span className="text">
              A venda desse evento já foi encerrada.{' '}
            </span>
          </div>
        </div>
      </div>
    );
  }

  if (status === 2 && ticketTypes.length > 0) {
    return (
      <div className="mobile-cart">
        <div className="inner">
          <div className="info">
            <span className="head">
              {ticketTypes.length > 1 ? 'A partir' : 'Apenas'}
            </span>
            <span className="price">{toMoney(lowerTicketType!.price)}</span>
          </div>
          <Button
            color="blue"
            fullWidth={true}
            onClick={onButtonClick}
            mode={isLoading && 'loading'}
            withBorder={undefined}
            type={undefined}
            className={undefined}
            htmlType={undefined}>
            Compre agora
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="mobile-cart">
      <div className={`disabled-event ${eventStatus[status].color}`}>
        <div className="icon-wrapper">{eventStatus[status].icon}</div>
        <div className="info">
          <Text className="title" color="#DD6B20">
            {eventStatus[status].title}
          </Text>
          <PendingEventWarning />
        </div>
      </div>
    </div>
  );
};

export default MobileCart;
